function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import BaseChannel from '@square/dashboard-data/adapters/channels/base-channel';
export default class Channel extends BaseChannel {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "namespace", 'api/v1');
  }
  shouldReloadAll() {
    return true;
  }

  // @ts-expect-error [can] not sure how to type this
  createRecord(store, type, snapshot) {
    const url = this.buildURL(type.modelName, null, snapshot, 'createRecord');

    // TODO [can] Oct 27,2022 - due to legacy reasons we need to send an empty payload to the BE
    // This should be removed once BE removes the payload requirement
    return jsonPost(url, {
      channel_type: snapshot.record.channelType,
      payload: {}
    });
  }
  list() {
    const url = this.buildURL('channels/channel', null);
    return this.ajax(url, 'GET');
  }
  enable(record) {
    const url = `${this.buildURL('channels/channel', record.id)}/enable`;
    return this.ajax(url, 'POST');
  }
  remove(record) {
    const url = `${this.buildURL('channels/channel', record.id)}/remove`;
    return jsonPost(url);
  }
}